import { contentConstants } from "../constants/contentConstants";
import { push } from "react-router-redux";
import { authHeader, getConvertedBase64Images } from "../helpers";
import { notify } from '../helpers/notification';
import { config } from "../helpers/config";
import i18n from 'i18next';

export const contentActionCreators = {
    requestArticles: () => async dispatch => {
        const url = `${config.base}api/Content/`;
        const response = await fetch(url);
        const articles = await response.json();

        dispatch({
            type: contentConstants.REQUEST_ARTICLES,
            articles
        });
    },

    getArticle: articleId => async dispatch => {
        if (!isNaN(articleId)) {
            const url = `${config.base}api/Content/${articleId}`;
            const response = await fetch(url);
            const article = await response.json();

            if (article.eventDate) {
                article.eventDate = article.eventDate.split("T")[0];
            }
            if (article.eventDateEnd) {
                article.eventDateEnd = article.eventDateEnd.split("T")[0];
            }

            dispatch({
                type: contentConstants.REQUEST_ARTICLE_TO_READ,
                articleToRead: article
            });
        }
    },

    requestNews: () => async dispatch => {
        const url = `${config.base}api/Content/news`;
        try {
            const response = await fetch(url);
            const news = await response.json();

            dispatch({
                type: contentConstants.REQUEST_NEWS,
                news
            });
        } catch (err) { }
    },

    requestAllNews: () => async dispatch => {
        const url = `${config.base}api/Content/newsList`;
        const response = await fetch(url);
        const news = await response.json();

        dispatch({
            type: contentConstants.REQUEST_NEWS,
            news
        });
    },

    requestEvents: () => async dispatch => {
        const url = `${config.base}api/Content/events`;
        try {
            const response = await fetch(url);
            const events = await response.json();

            dispatch({
                type: contentConstants.REQUEST_EVENTS,
                events
            });
        } catch (ex) { }
    },

    requestAllEvents: () => async dispatch => {
        const url = `${config.base}api/Content/eventsList`;
        const response = await fetch(url);
        const events = await response.json();

        dispatch({
            type: contentConstants.REQUEST_EVENTS,
            events
        });
    },

    createArticleForm: () => async dispatch => {
        dispatch({
            type: contentConstants.CREATE_ARTICLE_FORM
        });
    },

    submitPublication: (imagesNames) => async (dispatch, getState) => {
        const { form } = getState();
        const articleToAdd = form.ArticleForm.values;
        const url = `${config.base}api/Content/CreateArticle`;
        let images = articleToAdd.imagesFiles;

        let base64Images = await getConvertedBase64Images(images);
        articleToAdd.imagesNames = imagesNames;

        return fetch(url, {
            method: "POST",
            headers: authHeader(),
            body: JSON.stringify(articleToAdd)
        }).then(res => {
            if (res.ok) {
                dispatch({
                    type: contentConstants.POST_SUCCESS
                });
                dispatch(push("/"));
                dispatch(
                    notify({
                        message: i18n.t('article_added_success'),
                        status: 200
                    })
                );
            } else {
                dispatch({
                    type: contentConstants.POST_ERROR
                });
                dispatch(
                    notify({
                        message: i18n.t('error_occurred'),
                        status: 400
                    })
                );
            }
        });
    },

    editArticle: (imagesNames) => async (dispatch, getState) => {
        const { form } = getState();
        const articleToEdit = form.EditArticleForm.values;
        const url = `${config.base}api/Content/Edit`;

        let images = articleToEdit.imagesFiles;

        if (images && typeof images[0] !== "string") {
            let base64Images = await getConvertedBase64Images(images);
            articleToEdit.imagesNames = imagesNames;
        }

        return fetch(url, {
            method: "POST",
            headers: authHeader(),
            body: JSON.stringify(articleToEdit)
        }).then(res => {
            if (res.ok) {
                dispatch({
                    type: contentConstants.EDIT_SUCCESS
                });
                dispatch(push("/article/" + articleToEdit.id));
                dispatch(
                    notify({
                        message: i18n.t('article_edited_success'),
                        status: 200
                    })
                );
            } else {
                dispatch({
                    type: contentConstants.EDIT_ERROR
                });
                dispatch(
                    notify({
                        message: i18n.t('error_occurred'),
                        status: 400
                    })
                );
            }
        });
    },

    deleteArticle: articleId => async dispatch => {
        const url = `${config.base}api/Content/Delete?articleId=${articleId}`;

        return fetch(url, {
            method: "POST",
            headers: authHeader()
        }).then(res => {
            if (res.ok) {
                dispatch({
                    type: contentConstants.DELETE_SUCCESS
                });
                dispatch(push("/"));
                dispatch(
                    notify({
                        message: i18n.t('article_deleted_success'),
                        status: 200
                    })
                );
            } else {
                dispatch({
                    type: contentConstants.DELETE_ERROR
                });
                dispatch(
                    notify({
                        message: i18n.t('error_occurred'),
                        status: 400
                    })
                );
            }
        });
    },

    uploadImages: filesToUpload => async dispatch => {
        dispatch({ type: contentConstants.UPLOAD_FILE_BEGIN });

        const url = `${config.base}api/Content/UploadImages`;

        if (filesToUpload && filesToUpload.length > 0) {
            let base64Images = await getConvertedBase64Images(filesToUpload);
            const response = await fetch(url, {
                headers: authHeader(),
                method: "POST",
                body: JSON.stringify({ files: base64Images.convertedImages, names: base64Images.imagesNames })
            });

            if (response.status === 200) {
                const result = await response.json();
                dispatch({ type: contentConstants.UPLOAD_FILE_SUCCESS, result });
            } else {
                dispatch({ type: contentConstants.UPLOAD_FILE_ERROR });
                dispatch(
                    notify({
                        message: i18n.t('file_upload_error'),
                        status: 400
                    })
                );
            }
        }
    }

    //reloadVisibleContent: () => async (dispatch, getState) => {
    //    const { currentLanguage } = getState().language;
    //    try {
    //        const newsUrl = `${config.base}api/Content/news?lang=${currentLanguage}`;
    //        const newsResponse = await fetch(newsUrl);
    //        const news = await newsResponse.json();

    //        const eventsUrl = `${config.base}api/Content/events?lang=${currentLanguage}`;
    //        const eventsResponse = await fetch(eventsUrl);
    //        const events = await eventsResponse.json();

    //        dispatch({
    //            type: contentConstants.REQUEST_EVENTS,
    //            events
    //        });
    //        dispatch({
    //            type: contentConstants.REQUEST_NEWS,
    //            news
    //        });
    //    } catch (ex) {
    //        console.error("Error reloading content:", ex);
    //    }
    //},

};



//import { contentConstants } from "../constants/contentConstants";
//import { push } from "react-router-redux";
//import { authHeader, getConvertedBase64Images } from "../helpers";
//import {notify} from '../helpers/notification';
//import { config } from "../helpers/config";

//export const contentActionCreators = {
//    requestArticles: () => async dispatch => {
//        const url = `${config.base}api/Content/`;
//        const response = await fetch(url);
//        const articles = await response.json();

//        dispatch({
//            type: contentConstants.REQUEST_ARTICLES,
//            articles
//        });
//    },

//    getArticle: articleId => async dispatch => {
//        if (!isNaN(articleId)) {
//            const url = `${config.base}api/Content/${articleId}`;
//            const response = await fetch(url);
//            const article = await response.json();

//            if (article.eventDate) {
//                article.eventDate = article.eventDate.split("T")[0];
//            }
//            if (article.eventDateEnd) {
//                article.eventDateEnd = article.eventDateEnd.split("T")[0];
//            }

//            dispatch({
//                type: contentConstants.REQUEST_ARTICLE_TO_READ,
//                articleToRead: article
//            });
//        }
//    },

//    requestNews: () => async dispatch => {
//        const url = `${config.base}api/Content/news`;
//        try {
//            const response = await fetch(url);
//            const news = await response.json();

//            dispatch({
//                type: contentConstants.REQUEST_NEWS,
//                news
//            });
//        } catch (err) { }
//    },

//    requestAllNews: () => async dispatch => {
//        const url = `${config.base}api/Content/newsList`;
//        const response = await fetch(url);
//        const news = await response.json();

//        dispatch({
//            type: contentConstants.REQUEST_NEWS,
//            news
//        });
//    },

//    requestEvents: () => async dispatch => {
//        const url = `${config.base}api/Content/events`;
//        try {
//            const response = await fetch(url);
//            const events = await response.json();

//            dispatch({
//                type: contentConstants.REQUEST_EVENTS,
//                events
//            });
//        } catch (ex) { }
//    },

//    requestAllEvents: () => async dispatch => {
//        const url = `${config.base}api/Content/eventsList`;
//        const response = await fetch(url);
//        const events = await response.json();

//        dispatch({
//            type: contentConstants.REQUEST_EVENTS,
//            events
//        });
//    },

//    createArticleForm: () => async dispatch => {
//        dispatch({
//            type: contentConstants.CREATE_ARTICLE_FORM
//        });
//    },

//    submitPublication: (imagesNames) => async (dispatch, getState) => {
//        const { form } = getState();
//        const articleToAdd = form.ArticleForm.values;
//        const url = `${config.base}api/Content/CreateArticle`;
//        let images = articleToAdd.imagesFiles;

//        let base64Images = await getConvertedBase64Images(images);

//      //  articleToAdd.imagesFiles = base64Images.convertedImages;
//        articleToAdd.imagesNames = imagesNames;

//        return fetch(url, {
//            method: "POST",
//            headers: authHeader(),
//            body: JSON.stringify(articleToAdd)
//        }).then(res => {
//            if (res.ok) {
//                dispatch({
//                    type: contentConstants.POST_SUCCESS
//                });
//                dispatch(push("/"));
//                dispatch(
//                    notify({
//                        message: "Успешно добавяне на статия.",
//                        status: 200
//                    })
//                );
//            } else {
//                dispatch({
//                    type: contentConstants.POST_ERROR
//                });
//                dispatch(
//                    notify({
//                        message: "Възникнала е грешка, моля опитайте отново.",
//                        status: 400
//                    })
//                );
//            }
//        });
//    },

//    editArticle: (imagesNames) => async (dispatch, getState) => {
//        const { form } = getState();
//        const articleToEdit = form.EditArticleForm.values;

//        const url = `${config.base}api/Content/Edit`;

//        let images = articleToEdit.imagesFiles;

//        if (images && typeof images[0] !== "string") {
//            let base64Images = await getConvertedBase64Images(images);
//            //articleToEdit.imagesFiles = base64Images.convertedImages;
//            articleToEdit.imagesNames = imagesNames;
//        }

//        return fetch(url, {
//            method: "POST",
//            headers: authHeader(),
//            body: JSON.stringify(articleToEdit)
//        }).then(res => {
//            if (res.ok) {
//                dispatch({
//                    type: contentConstants.EDIT_SUCCESS
//                });
//                dispatch(push("/article/" + articleToEdit.id));
//                dispatch(
//                    notify({
//                        message: "Статията беше редактирана успешно!",
//                        status: 200
//                    })
//                );
//            } else {
//                dispatch({
//                    type: contentConstants.EDIT_ERROR
//                });
//                dispatch(
//                    notify({
//                        message: "Възникнала е грешка, моля опитайте отново.",
//                        status: 400
//                    })
//                );
//            }
//        });
//    },

//    deleteArticle: articleId => async dispatch => {
//        const url = `${config.base}api/Content/Delete?articleId=${articleId}`;

//        return fetch(url, {
//            method: "POST",
//            headers: authHeader()
//        }).then(res => {
//            if (res.ok) {
//                dispatch({
//                    type: contentConstants.DELETE_SUCCESS
//                });
//                dispatch(push("/"));
//                dispatch(
//                    notify({
//                        message: "Статията беше изтрита успешно!",
//                        status: 200
//                    })
//                );
//            } else {
//                dispatch({
//                    type: contentConstants.DELETE_ERROR
//                });
//                dispatch(
//                    notify({
//                        message: "Възникнала е грешка, моля опитайте отново.",
//                        status: 400
//                    })
//                );
//            }
//        });
//    },

//    uploadImages: filesToUpload => async dispatch => {
//        dispatch({ type: contentConstants.UPLOAD_FILE_BEGIN });

//		const url = `${config.base}api/Content/UploadImages`;

//		if (filesToUpload && filesToUpload.length > 0) {
//			let images = filesToUpload;
//			let base64Images = await getConvertedBase64Images(images);
//			let imagesFiles = base64Images.convertedImages;
//			let imagesNames = base64Images.imagesNames;
//			const response = await fetch(url, {
//				headers: authHeader(),
//				method: "POST",
//				body: JSON.stringify({ files: imagesFiles, names: imagesNames })
//			});
//            const result = await response.json();
//            const status = response.status;
//			if (status === 200) {
//				dispatch({ type: contentConstants.UPLOAD_FILE_SUCCESS, result:result });
//			} else {
//                dispatch({ type: contentConstants.UPLOAD_FILE_ERROR });
//                dispatch(
//                    notify({
//                        message: "Възникнала е грешка при качването на файл, моля опитайте отново или се свържете с администратор.",
//                        status: 400
//                    })
//                );
//			}
//		}
//	},
//};
